import { HomeDescription } from '@smooved/core';

export const houseTypeIcons = {
    [HomeDescription.Apartment]: 'apartment',
    default: 'home',
};
